"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParenConversionOptions = void 0;
const getUnitConversion_1 = require("./getUnitConversion");
const common_1 = require("@saffron/common");
exports.getParenConversionOptions = (ingredients) => {
    let conversionResult = {
        first: null,
        second: null,
    };
    let originalIg = null;
    for (const ig of ingredients) {
        if ("unit" in ig && ig.name && ig.amount) {
            conversionResult = getUnitConversion_1.getUnitConversion(ig);
            if (conversionResult.first) {
                originalIg = ig;
                break;
            }
        }
    }
    const { first, second } = conversionResult;
    if (first && second && originalIg) {
        const conversionIsImperial = common_1.isImperial(second.unit || "");
        const firstIg = common_1.ingredientToString(first);
        const secondIg = common_1.ingredientToString(second);
        return {
            ingredients: ingredients,
            textExamples: {
                both: common_1.ingredientToString(originalIg),
                imperial: conversionIsImperial ? secondIg : firstIg,
                metric: conversionIsImperial ? firstIg : secondIg,
            },
            takeParensUnit: conversionIsImperial ? "imperial" : "metric",
        };
    }
    return null;
};
//# sourceMappingURL=getParenConversionOptions.js.map